window.Popper = require("popper.js").default;
window.$ = window.jQuery = require("jquery");
require("../bootstrap/dist/js/bootstrap");

require("../plugins/modernizr-custom");

require("leaflet");
require("leaflet/dist/leaflet.css");

require("paroller.js");

require("@fancyapps/fancybox");
require("@fancyapps/fancybox/dist/jquery.fancybox.css");

require("slick-carousel");
require("./sliders");

require("./scripts");
require("./mapa");
// require("./privacidad");
require("./whatsapp");
require("./js-slider.min");
require("../menu");
/* $.whatsappButton({
	right: 20,
	bottom: 20,
	number: 56971596891,
	chatMode: true,
	profilePhoto: "./assets/images/avatar_wsp.jpg",
	iconButton: "./assets/images/whatsapp.png",
	sendMessageIcon: "./assets/images/flecha_wsp.png",
}); */

require("../promo_webpay");

$(window).scroll(function () {
    let scrollTop = $(this).scrollTop();
    if ($("body").not(".scroll") && scrollTop >= 10) {
        $("body").addClass("scroll");
    } else $("body").removeClass("scroll");
});

$(".scroll-to").click(function (e) {
    e.preventDefault();
    const target_id = $(this).attr("href");
    const $toElement = $(target_id);
    if ($(window).width() < 768 && $(this).hasClass("nav-link")) {
        $(".navbar-toggler").click();
    }

    $([document.documentElement, document.body]).animate(
        {
            scrollTop: $toElement.offset().top,
        },
        1000
    );

    return false;
});

function onScroll(event) {
    var scrollPos = $(document).scrollTop();
    $("#navbarCollapse .nav-item a").each(function () {
        var currLink = $(this);
        var refElement = $(currLink.attr("href"));
        if (
            refElement.position().top - 100 <= scrollPos &&
            refElement.position().top + refElement.height() > scrollPos
        ) {
            $("#navbarCollapse .nav-item a").removeClass("active");
            currLink.addClass("active");
        } else {
            // currLink.removeClass("active");
        }
    });
}
$(document).on("scroll", onScroll);

$(".cotizar").on("click", function () {
    $(this)
        .parents(".datos-planta")
        .fadeOut(function () {
            $(this).siblings(".cotiza-planta").fadeIn();
        });
});
$(".ver-planta").on("click", function () {
    console.log(
        '$(this).parents(".cotiza-planta")',
        $(this).parents(".cotiza-planta")
    );
    $(this)
        .parents(".cotiza-planta")
        .fadeOut(function () {
            $(this).siblings(".datos-planta").fadeIn();
        });
});

$(document).ready(function () {
    $(".js-slider-container").slider();
});

$(document).ready(function () {
    $("#loading").fadeOut();
});
